import { Injectable } from '@angular/core';

import { HttpClientService } from '../common/http-client.service';

@Injectable({
  providedIn: 'root',
})
export class OutgoingDocumentService {
  /**
   * Base URL for controller
   * @type {string}
   */
  private url: string = 'outgoing_documents';

  /**
   * Constructor
   * @param {HttpClientService} private httpClient Service for making HTTP requests with different methods
   */
  constructor(private httpClient: HttpClientService) {}

  /**
   * Build base URL for controller under outgoing jobs
   * @param  {number} outgoingJobId Id of outgoing job
   * @return {string}               URL
   */
  buildOutgoingDocumentsUrl(outgoingJobId: number): string {
    return `/outgoing_jobs/${outgoingJobId}/${this.url}`;
  }

  /**
   * Process document print
   * @param  {number}       id            Id of outgoing document
   * @param  {number}       outgoingJobId Id of outgoing job
   * @return {Promise<any>}               Server response
   */
  print(id: number, outgoingJobId: number): Promise<any> {
    return this.httpClient.get(`${this.buildOutgoingDocumentsUrl(outgoingJobId)}/item_print.json`, { id: id });
  }

  /**
   * Restart outgoing document processing
   * @param  {number}       id            Id of outgoing document
   * @param  {number}       outgoingJobId Id of outgoing job
   * @return {Promise<any>}               Server response
   */
  restart(id: number, outgoingJobId: number): Promise<any> {
    return this.httpClient.put(`${this.buildOutgoingDocumentsUrl(outgoingJobId)}/${id}/restart.json`, {});
  }

  /**
   * Resend a file share email without changing the original sent time
   * @param  {number}       id            Id of outgoing document
   * @param  {number}       outgoingJobId Id of outgoing job
   * @return {Promise<any>}               Server response
   */
  resend(id: number, outgoingJobId: number): Promise<any> {
    return this.httpClient.put(`${this.buildOutgoingDocumentsUrl(outgoingJobId)}/${id}/resend.json`, {});
  }

  sendFax(id: number, outgoingJobId: number): Promise<any> {
    return this.httpClient.get(`/${this.url}/send_fax.json`, { id: id, outgoing_job_id: outgoingJobId });
  }
}
